import DescriptionTemplateApi from '../../../api/bookkeeping/BookkeepingInvoiceDescriptionTemplateApi';
import InvoiceDescriptionTemplateDefaultModel from '../../models/InvoiceDescriptionTemplateDefaultModel';

const state = {
  invoicedescriptiontemplate: InvoiceDescriptionTemplateDefaultModel(),
};

const mutations = {
  setDescriptionTemplate(state, template) {
    state.invoicedescriptiontemplate = {
      ...InvoiceDescriptionTemplateDefaultModel(),
      ...template,
    };
  },

  updateDescriptionTemplate(state, payload) {
    state.invoicedescriptiontemplate = {
      ...state.invoicedescriptiontemplate,
      ...payload,
    };
  },
};

const actions = {
  storeDescriptionTemplate({ state }) {
    return new Promise((resolve, reject) => {
      DescriptionTemplateApi
        .store(state.invoicedescriptiontemplate)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  updateDescriptionTemplate({ state }) {
    return new Promise((resolve, reject) => {
      DescriptionTemplateApi
        .update(state.invoicedescriptiontemplate)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  showDescriptionTemplate({ state, commit }, id) {
    return new Promise((resolve, reject) => {
      DescriptionTemplateApi
        .show(id)
        .then(response => {
          commit('setDescriptionTemplate', response.data);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  calculateDescriptionTemplate({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      DescriptionTemplateApi
        .calculate(data)
        .then(response => {
          commit('updateDescriptionTemplate', response.data);
          return resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  clearDescriptionTemplateState({ commit }) {
    commit('setDescriptionTemplate', {});
  },
};

const getters = {
  getDescriptionTemplate: (state) => () => {
    return state.invoicedescriptiontemplate;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
